import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import BusinessIcon from "@mui/icons-material/Business";
import { Grid, TextField } from "@mui/material";
import { useContext, useEffect } from "react";
import { ThemeContext } from "../../../../../../contexts";

import "./accessDetails.css";

const AccessDeatils = (): JSX.Element => {
	const { theme } = useContext(ThemeContext);

	return (
		<div className="clinic-card-access-details">
			<div className="theme-plan-header">Access Details</div>
			<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
				Access To Entira Clinic Located in Lufkin, Texas
			</div>
			<div className="theme-plan-inner-section-margin" />

			<Grid container spacing={1}>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<LocationOnIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Location</div>
					<div className="access-content">
						1807 W. Frank, Suite 100. Lufkin, TX 75904<br></br>
						936-634-1400 <br></br>(Click on Address for Directions)
					</div>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<AccessTimeIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Hours of Operation</div>
					<div className="access-content">
						8.00 AM - 5:00 PM Monday thru Friday<br></br>
						Noon - 1.00 PM Closed
					</div>
				</Grid>
				<Grid item xs={12} sm={12} md={4} lg={4} xl={4} className="align-center">
					<BusinessIcon className="access-icon" style={{ color: theme.primary_color }} />
					<div className="access-header">Headquarters</div>
					<div className="access-content">
						Entira Medical Clinics<br></br> 14800 Quorum Drive, Suite 510<br></br> Dalas, TX 75254<br></br>
						<br></br>
						1-800-741-0135<br></br> Email: info@entiraclinic.com<br></br> Website www entiraclinic com
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default AccessDeatils;
